import { useLocation, Spin, Routes, Route, Navigate } from "../vendor/api.js";
// Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 24597, offsets 1158:138599. Structure and names inferred from code, not screenshots.
import * as React from "react";
import { loadArchivedChunk } from "../vendor/runtime.js";
import { loadArchivedModule } from "../vendor/runtime.js";
import * as AnalyticsContext from "../analytics/AnalyticsProvider.jsx";
import * as jsxRuntime from "react/jsx-runtime";
import { HomePage } from "../pages/HomePage.jsx";
import * as DocumentRoutesModule from "./DocumentRoutes.jsx";
import * as TestDocumentRoutesModule from "./TestDocumentRoutes.jsx";
import * as ModelRoutesModule from "./ModelRoutes.jsx";
import * as LocalizedPathsModule from "./localizedPaths.js";
import * as GetLanguageModule from "../i18n/getLanguage.js";
let ConsolePage = (0, React.lazy)(() =>
  Promise.all([
    loadArchivedChunk(2374),
    loadArchivedChunk(2422),
    loadArchivedChunk(9832),
    loadArchivedChunk(616),
    loadArchivedChunk(4028),
  ]).then(() => loadArchivedModule(52711)),
);
let ContactPage = (0, React.lazy)(() =>
  loadArchivedChunk(3389).then(() => loadArchivedModule(49852)),
);
let PageTracking = () => {
  let { pathname: pathname } = useLocation(),
    { track: track } = (0, AnalyticsContext.useAnalytics)(),
    i = (0, React.useRef)(Date.now()),
    n = (0, React.useRef)(null);
  return (
    (0, React.useEffect)(() => {
      ((i.current = Date.now()),
        (n.current = null),
        track("track", "view", {
          location: window.location.href,
          page: window.location.pathname,
        }),
        track("set", {
          location: window.location.href,
          page: window.location.pathname,
        }),
        document.querySelector("main")?.scrollTo({
          top: 0,
        }));
      let e = () => {
        null === n.current &&
          ((n.current = "close"),
          track("track", "platform_page_lifecycle", {
            duration: Date.now() - i.current,
            exit_type: "close",
          }));
      };
      return (
        window.addEventListener("beforeunload", e),
        () => {
          (window.removeEventListener("beforeunload", e),
            null === n.current &&
              track("track", "platform_page_lifecycle", {
                action: "platform_page_lifecycle",
                duration: Date.now() - i.current,
                exit_type: "navigation",
              }));
        }
      );
    }, [pathname, track]),
    null
  );
};
function PageRoutes() {
  return (
    <jsxRuntime.Fragment>
      <PageTracking />
      <React.Suspense
        fallback={
          <div
            className={
              "w-full h-[calc(100vh-54px)] flex items-center justify-center"
            }
          >
            <Spin />
          </div>
        }
      >
        <Routes>
          <Route path={"/"} element={<HomePage />} />
          <Route
            path={"/docs/*"}
            element={<DocumentRoutesModule.DocumentRoutes />}
          />
          {["development", "review", "staging"].includes("production") && (
            <Route
              path={"/test-docs/*"}
              element={<TestDocumentRoutesModule.TestDocumentRoutes />}
            />
          )}
          {""}
          <Route path={"/data-share"} element={<ConsolePage />} />
          <Route path={"/auto-close"} element={<ContactPage />} />
          <Route
            path={"/models/*"}
            element={<ModelRoutesModule.ModelRoutes />}
          />
          <Route
            path={"*"}
            element={
              <Navigate
                to={(0, LocalizedPathsModule.am)(
                  (0, LocalizedPathsModule.Oz)(
                    (0, GetLanguageModule.getLanguage)(),
                  ),
                  "welcome",
                )}
                replace={true}
              />
            }
          />
        </Routes>
      </React.Suspense>
    </jsxRuntime.Fragment>
  );
}
export { ConsolePage, ContactPage, PageTracking, PageRoutes };
